/**
 * @generated SignedSource<<c891ab7758c3537c50b8b22994c02068>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$data = {
  readonly expandButtonTextColor: string | null;
  readonly portals: ReadonlyArray<{
    readonly isFeatured: boolean | null;
    readonly portalId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"portal_HelpCenterPortal">;
  } | null>;
  readonly visualConfig: {
    readonly titleColor: string | null;
  } | null;
  readonly " $fragmentType": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement";
};
export type listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$key = {
  readonly " $data"?: listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listOfPortalsOnHelpCenter_HelpLayoutListOfHelpCenterPortalsAtomicElement",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "HelpLayoutPortalCard",
        "kind": "LinkedField",
        "name": "portals",
        "plural": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "portal_HelpCenterPortal"
          },
          {
            "kind": "ScalarField",
            "name": "isFeatured"
          },
          {
            "kind": "ScalarField",
            "name": "portalId"
          }
        ]
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "expandButtonTextColor"
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "titleColor"
        }
      ]
    }
  ],
  "type": "HelpLayoutPortalsListElement"
};

(node as any).hash = "f54a051de0b1e691ac7801678e0fe57d";

export default node;
